import { createAction, props } from '@ngrx/store';

export const addToCartSuccess = createAction(
  '[Punchout Return Component] Add To Cart Success',
  props<{ cartId: string }>()
);
